import React from "react";

const Lightbox = ({ imageUrl, onClose }) => {
    if (!imageUrl) return null;

    return (
        <div style={styles.lightboxOverlay} onClick={onClose}>
            <button 
                style={styles.lightboxClose} 
                onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                }}
            >
                &times;
            </button>
            <img 
                src={imageUrl} 
                alt="Full size" 
                style={styles.lightboxImage}
                onClick={(e) => e.stopPropagation()}
            />
        </div>
    );
};

const styles = {
    lightboxOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
    },
    lightboxImage: {
        maxWidth: '90vw',
        maxHeight: '90vh',
        objectFit: 'contain',
    },
    lightboxClose: {
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: 'none',
        border: 'none',
        fontSize: '40px',
        color: 'white',
        cursor: 'pointer',
        zIndex: 2001,
    },
};

export default Lightbox;
